<template>
  <q-dialog
    :model-value="step < totalSteps"
    no-backdrop-dismiss
    persistent
    maximized
    transition-show="fade"
    transition-hide="fade"
  >
    <div class="bg-white flex-center flex">
      <Bokeh v-if="$q.platform.is.desktop" transparent />
      <div class="flex column flex-center text-center">
        <q-circular-progress
          show-value
          indeterminate
          font-size="16px"
          size="250px"
          color="blue-7"
          track-color="white"
          :thickness="0.05"
        >
          <div class="q-px-lg q-py-md">
            <mira-icon />
            <transition name="textTransition" mode="out-in">
              <div
                v-if="loadingText"
                :key="loadingText"
                class="text-bold q-pt-md"
              >
                {{ loadingText }}
              </div>
            </transition>
          </div>
        </q-circular-progress>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import Bokeh from 'components/partials/Bokeh'

export default {
  components: {
    Bokeh
  },
  props: {
    step: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    }
  },
  computed: {
    loadingText () {
      switch (this.step) {
        case 1: return 'Checking Network Connection'
        case 2: return 'Checking System Version'
        case 3: return 'Loading System Settings'
        case 4: return 'Loading User Settings'
      }
      return null
    }
  }
}
</script>
